// ink-component
import React from 'react';
import { ThemeProvider } from 'styled-components';

import useResponsiveNav from '../_common/hooks/useResponsiveNav';
import NavWrapper from '../_common/NavWrapper/NavWrapper';
import DefaultMoreDropdown from '../_common/DefaultMoreDropdown/DefaultMoreDropdown';

import SubNavAnchor from './components/SubNavAnchor/SubNavAnchor';
import SubNavButton from './components/SubNavButton/SubNavButton';
import SubNavItem from './components/SubNavItem/SubNavItem';
import HorizontalNavBelt from '../HorizontalNav/components/HorizontalNavBelt/HorizontalNavBelt';

export interface SubNavProps extends React.HTMLAttributes<HTMLElement> {}

/**
 * @group SubNav
 * @purpose Create tertiary page navigation
 * @categories accessory
 * @order 1
 */
const SubNav = ({ className, style, children, ...otherProps }: SubNavProps) => {
  const [navItems, dropdownItems, navRef] = useResponsiveNav(React.Children.toArray(children));

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        isSubNav: true,
      })}
    >
      <NavWrapper {...otherProps} ref={navRef} role="navigation">
        {navItems}
        {dropdownItems.length > 0 && <DefaultMoreDropdown items={dropdownItems} trigger={SubNavButton} />}
      </NavWrapper>
    </ThemeProvider>
  );
};

SubNav.Anchor = SubNavAnchor;
SubNav.Button = SubNavButton;
SubNav.Item = SubNavItem;
SubNav.Belt = HorizontalNavBelt;

export { SubNavAnchorProps } from './components/SubNavAnchor/SubNavAnchor';
export { SubNavButtonProps } from './components/SubNavButton/SubNavButton';
export { SubNavItemProps } from './components/SubNavItem/SubNavItem';

SubNav.displayName = 'SubNav';

export default SubNav;
